var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sup',[_c('v-icon',{staticStyle:{"text-shadow":"none"},attrs:{"small":"","color":_vm.getSocialiteColor(_vm.driver)}},[_vm._v(_vm._s(_vm.getSocialiteIcon(_vm.driver)))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }